const lazyLoadBlock = (block) => {
  let status = false;

  window.addEventListener("scroll", () => {
    if (status === false) {
      status = true;
      setTimeout(() => {
        block();
      }, 1000);
    }
  });

  window.addEventListener("mousemove", () => {
    if (status === false) {
      status = true;
      setTimeout(() => {
        block();
      }, 1000);
    }
  });
};

export default lazyLoadBlock;
